export enum InteractionState {
    Active = 'active',
    Default = 'default',
    Focus = 'focus',
    Hover = 'hover',
}
